<ng-container *transloco="let t">

  <h2>{{ t('Safety Champions') }} {{ t('for') }} {{month}}</h2>

  <ng-container *ngIf="!champions"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

      <c-row>
        <c-col>
        <div class="justify-content-between">
          <button type="button" [cModalToggle]="tellmemoreModal.id" cButton style="width: fit-content" class="btn-light float-end">{{ t('Tell Me More About Safety Champions') }}</button>

          {{ t('Here is a list of your workers and the badges they have achieved in') }} {{month}}
        </div>
        <c-modal #tellmemoreModal alignment="center" id="tellmemoreModal">
          <c-modal-header>
            {{ t('More Info About Safety Champions') }}
          </c-modal-header>
          <c-modal-body>
            <p>{{ t('Safety Champions show how each of your workers are using OK Alone.') }}</p>

            <p>{{ t("At the end of each month we take all the workers' usage in OK Alone and review it to award a number of different badges and calculate a safety score.") }}</p>

            <h6>{{ t('What are the Badges?') }}</h6>

            <p>{{ t('Each month your workers are awarded a number of badges based on how they used the system. These badges include features used, milestones reached and their rankings in relation to other workers in the company, country and world wide.') }}</p>

            <h6>{{ t('How is the Score Calculated?') }}</h6>

            <p>{{ t('Each month a score out of 100 is awarded to each worker. This takes into account a number of safety factors including missed check ins, location monitoring, start shift and check in reminders. It is possible to get 100/100, however any score over 75 is classed as very good.') }}</p>
          </c-modal-body>
        </c-modal>
      </c-col>
      </c-row>
      <ng-container *ngIf="champions">
      
      <c-row>

        <div class="row hidden-print modal-body">
          <div class="col-12 col-md-6 col-lg-3"></div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
            <h3>{{ t('Report Card') }} <button type="button" class="btn btn-link" data-bs-toggle="popover"  data-bs-content="We have now introduced Report Cards, which give a monthly summary of each worker"><i class="fa-solid fa-circle-info"></i></button></h3>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
            <h3>{{ t('Monthly Awards') }} <button type="button" class="btn btn-link" data-bs-toggle="popover"  data-bs-content="At the end of each month we look at worker's OK Alone usage and calculate a safety score. We then award a number of badges based on features they have used and how well they have done against workers in the same company, country and across the world."><i class="fa-solid fa-circle-info"></i></button></h3>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
            <h3>{{ t('Yearly Awards') }} <button type="button" class="btn btn-link" data-bs-toggle="popover"  data-bs-content="As workers continue to use OK Alone, they can reach a number of milestones which show they are achieving safety goals. These awards take the whole year's usage into account and accumulate over time. The highest award is 5 stars for Safe Shifts and Safe Weeks."><i class="fa-solid fa-circle-info"></i></button></h3>
          </div>

        </div>
        </c-row>
    <c-row >
      <c-card *ngFor="let champion of champions, let i = index">
        <c-row>
          <c-col class="col-12 col-md-6 col-lg-3">

            <div>
              <h4><span class="text-warning">{{u.ordinal(i+1)}}</span>&nbsp;&nbsp;<b>{{champion.name}}</b> <br/>{{champion.score}}</h4>
              <button type="button" cButton variant="ghost" class="aria-hidden" (click)="showPopup(champion)"><i class="fa-solid fa-circle-question text-info"></i></button>

            </div>
          </c-col>
          <c-col class="col-12 col-md-6 col-lg-3">
            <div>
              <ng-container *ngFor="let report of champion.reportcard">
                <a href="{{report.img_url}}" target="_new">
                <img src="{{report.img_url}}" class="img-fluid reportcard-img ">
                </a>
              </ng-container>
            </div>
          </c-col>
          <c-col class="col-12 col-md-6 col-lg-3">
            <div class="badge-container">
              <ng-container *ngFor="let badge of champion.badges">

                <img src="{{badge.img_url}}" class="img-fluid badge-img">

              </ng-container>
            </div>
          </c-col>
          <c-col class="col-12 col-md-6 col-lg-3">
            <div class="badge-container">
              <ng-container *ngFor="let badge of champion.yearly_badges">

                <img src="{{badge.img_url}}" class="img-fluid badge-img">

              </ng-container>
            </div>
          </c-col>
      </c-row>
      </c-card>
    </c-row>
  </ng-container>

  <div class="card">
    <div class="card-body">
    <h4>{{ t('Why do some workers have no Scores or Badges??') }}</h4>
    {{ t('To get a monthly score or badges the worker must be regularly using OK Alone system. If they have used the system even just once they should start being awarded badges. The more they use the system and stay safe, the higher their score will be. To start getting the highest scores, a worker must be using the app at least 3 times a week for shifts of 2 hours or more.') }}
  </div>
</div>

<c-modal #summaryModal alignment="center" id="summaryModal" *ngIf="popup">
  <c-modal-header>
    <b>{{popup.name}}</b>
  </c-modal-header>
  <c-modal-body [innerHtml]="popup.summary">
  </c-modal-body>
</c-modal>



</ng-container>
